var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3025 4.8125L11.8388 5.27625L7.62125 9.49375C7.53991 9.57576 7.44313 9.64086 7.3365 9.68528C7.22988 9.7297 7.11551 9.75257 7 9.75257C6.88449 9.75257 6.77012 9.7297 6.6635 9.68528C6.55687 9.64086 6.46009 9.57576 6.37875 9.49375L2.16125 5.27625L1.6975 4.8125L2.625 3.885L3.08875 4.34875L7 8.26L10.9113 4.34875L11.375 3.885L12.3025 4.8125Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationDropdownIcon);
export default __webpack_public_path__ + "static/media/pagination-dropdown-icon.64ba48de2a3ac56eec66c6799dfe8bab.svg";
export { ForwardRef as ReactComponent };